/**
 * Mobile route that displays the add-property flow. On desktop, the
 * `PropertiesGridPage` opens this same dialog inline.
 */

import { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { AddPropertyDialog } from '@/components/Property/AddPropertyDialog';

export const AddPropertyPage = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!open) {
      navigate('/properties', { replace: true });
    }
  }, [open, navigate]);

  return (
    <Container sx={{ py: 4 }}>
      <AddPropertyDialog
        open={open}
        onClose={() => setOpen(false)}
        onCreated={(id) => {
          setOpen(false);
          navigate(`/properties/${id}`, { replace: true });
        }}
      />
    </Container>
  );
};

export default AddPropertyPage;
